import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { IProductDataV3 } from '@df/catalog/product/product';
import { ProductConfiguration } from '@df/module-product-configuration/model/product-configuration';
import { optionLabelPipe } from '@df/ui/common/option-label.pipe';
import { PriceComponent } from '@df/ui/price/price.component';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { UiComponent } from '@df/ui/ui.component';
import { Product } from '../../product.decorator';
import { Nexus } from '@tomandco/nexus-api-types';

/**
 * Displays product price
 */
@Component({
    standalone: true,
    imports: [PriceComponent, TranslationModule],
    selector: 'product-view-price',
    templateUrl: './product-view-price.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductViewPriceComponent extends UiComponent {
    /**
     * Current selection price
     */
    protected price!: number;

    /**
     * Current selection orginal price
     */
    protected orgPrice?: number;

    /**
     * If current price can increase after configuirable option selection
     */
    protected isFromPrice!: boolean;

    /**
     * Product configuration service
     */
    private productConfiguration = inject(ProductConfiguration);

    override ngOnInit(): void {
        this.productConfiguration.priceChange$.subscribe(() => this.updatePriceValue());
        this.updatePriceValue();
        super.ngOnInit();
    }

    /**
     * Update prices by config
     */
    private updatePriceValue() {
        const request = this.productConfiguration.toBasketRequest() as Nexus.Lib.Basket.BasketRequestData;
        this.price = this.product.getPrice(request);
        this.orgPrice = this.product.getOrgPrice(request);
        this.isFromPrice = this.productConfiguration.isFromPrice();
        this.detectChanges();
    }

    private get product(): Product<IProductDataV3> {
        return this.productConfiguration.product$.value as Product<IProductDataV3>;
    }

    get soldBy(): string | undefined | number {
        const soldBy = this.product?.getAttr('sold_by') as number;
        if (soldBy) {
            return optionLabelPipe(soldBy, 'sold_by');
        }
        return undefined;
    }

    get mapPrice(): number | undefined {
        return this.product?.getAttr('map_price');
    }
}
